module.exports = __webpack_public_path__ + "static/media/card-stress.b81e563a.svg";